import { render, staticRenderFns } from "./Noc_all.vue?vue&type=template&id=bf4b71a6&"
import script from "./Noc_all.vue?vue&type=script&lang=js&"
export * from "./Noc_all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports